import { useInspectionStore } from '../store';
import { DocumentsOnInspectionView } from 'presentation/document/documentsToDocumentsOnInspectionView';
import { DocumentsOnTemplateView } from 'presentation/document/documentsOnTemplateView';
import { InspectionOnView } from 'presentation/inspection/inspectionOnView';
import { InspectionModel } from 'shared/domain/inspection/inspectionModel';

export interface UseInspectionResult {
  inspection: InspectionOnView | undefined;
  inspectionModel: InspectionModel | undefined;
  inspectionTemplateDocuments: DocumentsOnTemplateView;
  inspectionDocuments: DocumentsOnInspectionView;
  inspectionDocumentsLoading: boolean;
  loading: boolean;
  refresh: () => void;
  getInspection: () => void;
  setInspectionModel: (model: InspectionModel | undefined) => void;
  setInspection: (model: InspectionModel | undefined) => void;
  setIgnoreDocuments: (ignore: boolean) => void;
}

export function useInspection(): UseInspectionResult {
  const inspection = useInspectionStore.use.inspection();
  const inspectionModel = useInspectionStore.use.inspectionModel();
  const inspectionTemplateDocuments =
    useInspectionStore.use.inspectionTemplateDocuments();
  const inspectionDocuments = useInspectionStore.use.inspectionDocuments();
  const inspectionDocumentsLoading = useInspectionStore.use.inspectionDocumentsLoading();
  const loading = useInspectionStore.use.inspectionLoading();
  const reloadInspection = useInspectionStore.use.reloadInspection();
  const setInspectionModel = useInspectionStore.use.setInspectionModel();
  const setIgnoreDocumentsStore = useInspectionStore.use.setIgnoreDocumentsStore();

  return {
    inspection,
    inspectionModel,
    inspectionTemplateDocuments,
    inspectionDocuments,
    inspectionDocumentsLoading,
    loading,
    refresh: reloadInspection,
    getInspection: reloadInspection,
    setInspectionModel,
    setInspection: setInspectionModel,
    setIgnoreDocuments: setIgnoreDocumentsStore,
  };
}
